























































































import Vue from 'vue';

import ClickableArea from '@/components/ClickableArea.vue';
import EventBus from '@/utils/EventBus';
import Task from '@/models/soukai/Task';

export default Vue.extend({
    components: {
        ClickableArea,
    },
    props: {
        task: {
            type: Object as () => Task,
            required: true,
        },
    },
    computed: {
        renderedName(): string {
            const html = this.$options.filters!.markdown(this.task.name || '');

            // Strip surrounding p tag
            return html.substring(3, html.length - 5);
        },
        renderedDueAt(): string {
            return this.$dayjs(this.task.dueAt).calendar(undefined, {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]',
                nextWeek: 'dddd',
                lastDay: '[Yesterday]',
                lastWeek: '[Last] dddd',
                sameElse: 'DD/MM/YYYY',
            });
        },
    },
    methods: {
        async editDueAt() {
            try {
                const date = await this.$ui.openDialog(
                    () => import('@/dialogs/DatePicker.vue'),
                    { date: this.task.dueAt },
                );

                await this.updateDueAt(date);
            } catch (error) {
                // dialog cancelled, nothing to do here
            }
        },
        async updateDueAt(date: Date | null) {
            await this.$ui.updateModel(
                this.task,
                task => task.update({ dueAt: date }),
                ['dueAt'],
            );
        },
        async edit(field: string) {
            this.$tasks.setEditing(true);

            await this.$nextTick();

            EventBus.emit('focus', field);
        },
        async toggleStarred() {
            await this.$ui.updateModel(
                this.task,
                task => task.toggleStarred(),
                ['priority'],
            );
        },
        remove() {
            this.$ui.openDialog(
                () => import('@/dialogs/RemoveTask.vue'),
                { task: this.task },
            );
        },
    },
});
